import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function BusinessAdministrationLevel3() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Business and Administration Apprenticeship Level 3
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Advanced Business Skills for Your Career
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Course Overview Section */}
        <section id="course-overview" style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Course Overview
                  </h3>
                  
                  <div className="mb-4 p-4" style={{
                    backgroundColor: '#fef3c7',
                    borderRadius: '12px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', fontStyle: 'italic' }}>
                      <strong>Important:</strong> You need to be employed to start an Apprenticeship; please include the full contact details of your employer within your application. If you are unable to secure employment, you could enrol on a full-time study programme and transfer to an Apprenticeship later.
                    </p>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Administration skills are crucial to the effectiveness and efficiency of any organisation. By completing this qualification, you will demonstrate a thorough understanding of current theory and practice, which is respected and recognised by employers.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Mandatory units include:
                  </h4>

                  <div className="mb-4">
                    <div className="p-3 mb-2" style={{
                      backgroundColor: '#F5EBFA',
                      borderRadius: '8px',
                      borderLeft: '3px solid #7B3F9E'
                    }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>· Communicate in a business environment</span>
                    </div>
                    <div className="p-3 mb-2" style={{
                      backgroundColor: '#F5EBFA',
                      borderRadius: '8px',
                      borderLeft: '3px solid #7B3F9E'
                    }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>· Manage personal and professional development</span>
                    </div>
                    <div className="p-3 mb-2" style={{
                      backgroundColor: '#F5EBFA',
                      borderRadius: '8px',
                      borderLeft: '3px solid #7B3F9E'
                    }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>· Principles of business communication and information</span>
                    </div>
                    <div className="p-3 mb-2" style={{
                      backgroundColor: '#F5EBFA',
                      borderRadius: '8px',
                      borderLeft: '3px solid #7B3F9E'
                    }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>· Principles of administration</span>
                    </div>
                    <div className="p-3" style={{
                      backgroundColor: '#F5EBFA',
                      borderRadius: '8px',
                      borderLeft: '3px solid #7B3F9E'
                    }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>· Principles of business</span>
                    </div>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    In your workplace, you could perform a variety of tasks such as producing documents and preparing notes, organising and co-ordinating events and meetings, developing and delivering presentations, and managing teams.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The course includes a tutorial programme to cover subjects linked to the work environment such as email etiquette, professional letter writing, time management and personal guidance on equality and diversity, safeguarding and money matters.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Assessment Methods Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Assessment Methods
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Assessment is in the workplace and by an Assessor who has specific sector knowledge. You will be required to build an online portfolio using various assessment methods such as observation, professional discussion, work product and witness testimony.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The knowledge element will be assessed via online tests after each learning outcome has been taught and you feel ready to sit a multiple-choice exam.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Progression Options Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Progression Options
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    You could further your studies in team leading/management, customer services or other sector specific qualifications. Most apprentices can expect to be offered a permanent contract with their employer and work towards possible careers in HR Administrator Management, Office Management, Personal Assistant, etc.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Course Details and Requirements Table */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1.05rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '25px 30px', color: '#fff', fontWeight: '600', backgroundColor: '#0369a1', width: '35%' }}>
                            Course Title
                          </td>
                          <td style={{ padding: '25px 30px', color: '#334155' }}>
                            Business and Administration Apprenticeship Level 3
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}>
                          <td style={{ padding: '25px 30px', color: '#fff', fontWeight: '600', backgroundColor: '#0369a1' }}>
                            Entry Requirements
                          </td>
                          <td style={{ padding: '25px 30px', color: '#334155' }}>
                            <p style={{ marginBottom: '15px' }}>
                              You need five GCSEs in the A* to C or 9 to 4 range including English and Maths, or a relevant Level 2 qualification. Course entry is subject to an initial assessment in order to determine the appropriate level of study and a successful interview.
                            </p>
                            <p style={{ marginBottom: '15px' }}>
                              You must be working in an administrative environment with responsibility within you job role. An assessment of your job role will be made to ensure there is enough scope and responsibility for you to achieve the qualification as it is based on levels of competence.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: '25px 30px', color: '#fff', fontWeight: '600', backgroundColor: '#0369a1' }}>
                            Attendance Requirements
                          </td>
                          <td style={{ padding: '25px 30px', color: '#334155' }}>
                            You are required to attend College for one day per week, usually Wednesdays, and study remotely.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default BusinessAdministrationLevel3;